import { render, staticRenderFns } from "./DynamicDialogBody.vue?vue&type=template&id=bc940b6c&scoped=true"
import script from "./DynamicDialogBody.vue?vue&type=script&lang=js"
export * from "./DynamicDialogBody.vue?vue&type=script&lang=js"
import style0 from "./DynamicDialogBody.vue?vue&type=style&index=0&id=bc940b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc940b6c",
  null
  
)

export default component.exports